import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import {
    getComments,
    setSelectedItem,
    manageListComment,
    setIsEmptyCompareData,
    showComment,
    clearLastComments,
    setViewComment,
    removeMention
} from '../../actions/CommentAction'
import { Spin, DatePicker, Badge } from 'antd'
import moment from 'moment'

import { VideoView } from '../assets-view/VideoView'
import DocumentView from '../document-view/DocumentView'
import { Select } from 'antd'
import "./newListComments.css"
import fileExtension from 'file-extension'
import AttachIcon from './AttachIcon'
import SVGView from '../assets-view/SVGView'
import fileextension from 'file-extension'
import {

    handleSetSrc,

} from '../../utils/index'
const { Option } = Select;


const formatDate = "DD-MM-YYYY"
const formatDateUTC = "YYYY-MM-DD"

function isCurrentUserMentioned(mentions, currentUser) {
    try {
        const index = mentions.findIndex(mention => mention.user === currentUser && !mention.view)
        return (index >= 0)
    } catch (error) {
        return false
    }

}
function DartComment(props) {
    const { comment, comment: { user_creator }, onClick, userId } = props
    const commentToShow = (comment.comment && comment.comment.length > 250)
        ? comment.comment.slice(0, 247) + "..."
        : (comment.attachedFile &&
            fileExtension(comment.attachedFile.originalURL) !== 'mp3' ?
            comment.attachedFile.name + '.' + fileExtension(comment.attachedFile.originalURL) : (comment.attachedFile ? 'Audio.mp3' : comment.comment))

    const showNotificacionBadge = isCurrentUserMentioned(comment.mentions, userId)
    const handlerClick = () => {
        onClick(comment, showNotificacionBadge)
    }
    return (
        <React.Fragment>
            <div className="bb-mod-left__item" onClick={handlerClick}>
                <div className='mention-notification'>
                    {showNotificacionBadge && <Badge status="warning" text={""} />}
                </div>
                <figure>

                    <img src={user_creator && user_creator.avatar
                        ? user_creator.avatar
                        : '/images/icons/user-icon.svg'}
                        alt="avatar"
                        className="dart-list-avatar" />
                </figure>

                <div className="info">
                    <h3>{user_creator.name}</h3>
                    {comment.attachedFile &&
                        <span style={{ float: 'left' }}>
                            <AttachIcon width={20} height={20} />
                        </span>
                    }
                    <p style={{
                        display: comment.attachedFile ? 'inline-block' : 'block',
                        color: comment.attachedFile ? '#0096d6' : 'white',
                        fontWeight: comment.attachedFile ? 'bold' : null,
                        marginLeft: comment.attachedFile ? '2px' : 0
                    }}>
                        {commentToShow}
                    </p>
                </div>
                <AssetAvatar document={comment.document} />
            </div>

        </React.Fragment>
    )


}

function AssetAvatar(props) {
    const { document } = props
    return (
        <React.Fragment>
            <div className="image">

                {
                    document.type === 'image' &&
                        fileextension(document.originalURL) === 'svg'
                        ? (<SVGView comeFromNewListComments={true} src={document.originalURL} assetId={document._id} />)

                        :
                        document.type === 'image' &&
                            fileextension(document.originalURL) !== 'png'

                            ? (<img
                                src={handleSetSrc(document)}
                                alt="assetPreview"
                                className="dart-list-asset-preview" />)

                            :
                            (document.type === 'image' &&
                                <img
                                    src={handleSetSrc(document)}
                                    alt="assetPreview"
                                    className="dart-list-asset-preview" />
                            )
                }

                {
                    document.type === 'video' && <VideoView
                        url={document.mediaQualityURL}
                        disableDefaultControls={true}
                        from='list'
                        divWidth={30}
                        autoPlay={false}
                        muted={true}
                        className="dart-list-video"
                    />
                }
                {
                    document.type === 'document' &&
                    <DocumentView
                        item={document}
                        from={`middleView`}
                        className="dart-list-document"
                        listComment={true} />
                }
            </div>
        </React.Fragment>
    )
}


function NewListCommentsHeader(props) {

    const { onClose, intl, isFetching, onChangeFilterByHandlerAntDesign, onchangeFromDate, fromDate, toDate, onchangeToDate } = props
    const toDateUTC = toDate.split("-").reverse().join("-");
    const fromDateUTC = fromDate.split("-").reverse().join("-");

    return (
        <React.Fragment>
            <div className="bb-mod-left__top" >
                <h2>{intl.formatMessage({ id: "lastestCommentsTitle" })}</h2>
                <p>{intl.formatMessage({ id: "lastestCommentsSubTitle" })}</p>

                <span className="bb-mod-left__close" onClick={onClose}><svg width="20" height="20" viewBox="0 0 33 33" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.4614 12.2165C10.7039 12.4602 11.0226 12.5815 11.3414 12.5815C11.6601 12.5815 11.9788 12.4602 12.2213 12.2165C12.7076 11.7302 12.7076 10.9415 12.2213 10.4553L2.26527 0.489192C1.77903 0.00295153 0.991547 0.00295153 0.505306 0.489192C0.0190648 0.975433 0.0190648 1.76417 0.505306 2.25041L10.4614 12.2165Z"
                        fill="white" />
                    <path
                        d="M18.0802 16.3189L32.1362 2.2504C32.6225 1.76416 32.6225 0.975425 32.1362 0.489184C31.65 0.0029427 30.8625 -0.212053 30.3763 0.275438L15.4415 15.0089H15.0716V15.4402L0.321827 30.3874C-0.164413 30.8736 -0.0719153 31.6624 0.413076 32.1486C0.655571 32.3923 1.02056 32.5136 1.33931 32.5136C1.65805 32.5136 1.9993 32.3923 2.24179 32.1486L16.309 18.0814L30.37 32.1498C30.6125 32.3936 30.935 32.5148 31.2525 32.5148C31.57 32.5148 31.8912 32.3936 32.1337 32.1498C32.62 31.6636 32.6212 30.8749 32.135 30.3886L18.0802 16.3189Z"
                        fill="white" />
                </svg>
                </span>
                <div className="mod-left-filters">
                    <div className="mod-left-filter-r">
                        <p>{intl.formatMessage({ id: "lastcommentsFilterBy" })}</p>
                        <div className="select-content">
                            <Select
                                style={{ minWidth: "100px", width: '100%' }}
                                labelInValue
                                defaultValue={{ key: 'all' }}
                                dropdownStyle={{ position: "fixed" }}
                                onChange={onChangeFilterByHandlerAntDesign}
                                disabled={isFetching}
                            >
                                <Option value="mentions" >{intl.formatMessage({ id: "mentions" })}</Option>
                                <Option value="videos">{intl.formatMessage({ id: "searche_tooltip_video" })}</Option>
                                <Option value="images">{intl.formatMessage({ id: "searche_tooltip_image" })}</Option>
                                <Option value="documents">{intl.formatMessage({ id: "documents" })}</Option>
                                <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
                            </Select>
                        </div>
                    </div>
                    <div className="mod-left-filter-l">
                        <div className="filter-date">
                            <div>
                                <DatePicker
                                    className="datePickerBunkey"
                                    format={formatDate}
                                    size="middle"
                                    value={(fromDate !== "") ? moment(fromDate, formatDate) : null}
                                    showToday={false}
                                    placeholder={intl.formatMessage({ id: "from_date" })}
                                    onChange={onchangeFromDate}
                                    disabled={isFetching}
                                    disabledDate={d => !d || d.isAfter(toDateUTC)}
                                />
                            </div>
                        </div>
                        <div className="filter-date">
                            <div className="">
                                <DatePicker
                                    className="datePickerBunkey"
                                    format={formatDate}
                                    size="middle"
                                    value={(toDate !== "") ? moment(toDate, formatDate) : null}
                                    showToday={false}
                                    placeholder={intl.formatMessage({ id: "to_date" })}
                                    onChange={onchangeToDate}
                                    disabledDate={d => !d || d.isBefore(fromDateUTC)}
                                    disabled={isFetching}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )

}
function CommentsSpin(props) {

    return (<React.Fragment>
        <div className="spinner-comment-div" style={(!props.show) ? { display: "none" } : {}}>
            <Spin spinning={true} />
        </div>
    </React.Fragment>)
}
class NewListComments extends Component {
    constructor(props) {
        super(props)
        this.filterByDefault = "all"
        this.state = {
            limit: 30,
            filterBy: this.filterByDefault,
            fromDate: "",
            toDate: ""

        }
    }

    componentDidMount() {

        const { clearLastComments } = this.props


        clearLastComments().then(() => {

            const { workclient, page } = this.props
            const { limit } = this.state

            let order = {
                field: ['createdAt'],
                type: 'asc',
                limit: limit,
                page: page
            }

            this.props.getComments(workclient, null, order)

        })




    }
    componentWillUnmount() {
        this.props.clearLastComments()
    }
    componentDidUpdate(prevProps, prevState) {
        const { filterBy, limit, fromDate, toDate } = this.state
        const { getComments, workclient } = this.props
        if (filterBy !== prevState.filterBy || fromDate !== prevState.fromDate || toDate !== prevState.toDate) {
            let order = {
                field: ['createdAt'],
                type: 'asc',
                limit: limit,
                page: 1
            }

            const query = this.getQuery(filterBy, fromDate, toDate)
            getComments(workclient, query, order)

        }

    }
    onClickCommentHandler = (item, hasRemoveMention = false) => {
        const { setViewComment, removeMention } = this.props
        this.props.showComment()
        this.props.setSelectedItem(item.document._id, item._id)
        this.props.onClose()

        if (hasRemoveMention) {
            setViewComment(item)
            removeMention(item._id)

        }
    }

    onClickShowMoreCommentsHandler = () => {
        const { filterBy, limit, fromDate } = this.state
        const { page, workclient, getComments } = this.props
        let order = {
            field: ['createdAt'],
            type: 'asc',
            limit: limit,
            page: page + 1
        }
        const query = this.getQuery(filterBy, fromDate)
        getComments(workclient, query, order)
    }

    onChangeFilterByHandler = (event) => {
        const { clearLastComments } = this.props
        this.setState({ filterBy: event.target.value, fromDate: "", toDate: "" });
        clearLastComments()
    }

    onChangeFilterByHandlerAntDesign = ({ key }) => {
        const { clearLastComments } = this.props
        this.setState({ filterBy: key, });
        clearLastComments()
    }

    onchangeFromDate = (moment, dateString) => {
        const { clearLastComments } = this.props
        clearLastComments()
        this.setState({ fromDate: dateString })

    }
    onchangeToDate = (moment, dateString) => {
        const { clearLastComments } = this.props
        clearLastComments()
        this.setState({ toDate: dateString })

    }
    getQuery = (key, fromDate, toDate) => {
        const { user } = this.props
        let query = []
        switch (key) {
            case 'mentions':
                query = [
                    ...query, {
                        field: 'mentions.email',
                        type: 'eq',
                        value: user.email
                    }
                ]
                break;
            case 'videos':
                query = [
                    ...query, {
                        field: 'document.type',
                        type: 'eq',
                        value: 'video',
                        final: true
                    }
                ]
                break;
            case 'images':
                query = [
                    ...query, {
                        field: 'document.type',
                        type: 'eq',
                        value: 'image',
                        final: true
                    }
                ]
                break;
            case 'documents':
                query = [
                    ...query, {
                        field: 'document.type',
                        type: 'eq',
                        value: 'document',
                        final: true
                    }
                ]
                break;

            default:
                query = []
                break;
        }

        if (fromDate && fromDate !== "") {
            const fromDateMoment = moment(fromDate, formatDate)
            query.push({ field: "fromDate", type: "gte", final: true, value: fromDateMoment.format(formatDateUTC) })
        }

        if (toDate && toDate !== "") {
            const toDateMoment = moment(toDate, formatDate)
            query.push({ field: "toDate", type: "lt", final: true, value: toDateMoment.format(formatDateUTC) })
        }
        return query

    }


    render() {
        const { onClose, data, isFetching, headers, intl, userId } = this.props
        const { filterBy, fromDate, toDate } = this.state
        const dataComments = data.map(comment => {
            return <DartComment
                key={`comment_${comment._id}`}
                comment={comment}
                userId={userId}
                // onClick={() => { this.onClickCommentHandler(comment) }} />
                onClick={this.onClickCommentHandler} />
        })
        const renderedElements = dataComments.length
        const totalComments = (headers && headers["x-pagination-total-count"]) ? parseInt(headers["x-pagination-total-count"]) : 0
        const disabledShowMoreButton = (isFetching || (dataComments.length === totalComments))
        const showNoCommentsMessage = (dataComments.length === 0 && !isFetching)

        return (
            <React.Fragment>
                <div className="bb-upload">
                    <div className="bb-mod-left enabled" style={{ width: "100%" }}>
                        <NewListCommentsHeader
                            onClose={onClose}
                            filterBy={filterBy}
                            onChangeFilterByHandler={this.onChangeFilterByHandler}
                            onChangeFilterByHandlerAntDesign={this.onChangeFilterByHandlerAntDesign}
                            isFetching={isFetching}
                            intl={intl}
                            onchangeFromDate={this.onchangeFromDate}
                            fromDate={fromDate}
                            onchangeToDate={this.onchangeToDate}
                            toDate={toDate}

                        />
                        <div className="bb-mod-left__items">
                            <div className="items-scroll">
                                {dataComments}
                                <CommentsSpin show={isFetching} />
                                <div className="bb-mod-left__buttons" style={{ display: (showNoCommentsMessage) ? "none" : "" }}>
                                    <p>{`${intl.formatMessage({ id: "showing" })} ${renderedElements} ${intl.formatMessage({ id: "of" })} ${totalComments}`}</p>
                                    <button disabled={disabledShowMoreButton}
                                        onClick={this.onClickShowMoreCommentsHandler}
                                        style={(disabledShowMoreButton) ? { opacity: "80%", cursor: "not-allowed" } : {}}>
                                        {`${intl.formatMessage({ id: "show_more" })}`}
                                    </button>
                                </div>
                                <div className="bb-mod-left__center-content" style={{ display: (showNoCommentsMessage) ? "grid" : "" }}>
                                    <div className="center-block">
                                        <figure><img src="images/bitbang/icon-empty-block.svg" alt="" /></figure>
                                        <h4>{intl.formatMessage({ id: "there_is_no_comments" })}</h4>
                                        <p>{intl.formatMessage({ id: "invite_to_coment" })}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </React.Fragment>
        )


    }


}

const mapStateToProps = state => {
    return {

        workclient: state.client.workclient,
        user: state.authUser.user,
        data: state.comments.data,
        headers: state.comments.headers,
        isFetching: state.comments.isFetching,
        page: state.comments.lastCommentsPage,
        userId: state.authUser.user._id

    }
}

const mapDispatchToProps = {
    getComments,

    setSelectedItem,
    manageListComment,
    setIsEmptyCompareData,
    showComment,
    clearLastComments,
    setViewComment,
    removeMention
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewListComments)))